import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { createStyles, FormHelperText, TextField, withStyles } from '@material-ui/core';
import { checkRequired } from './utils';

var styles = function styles() {
  return createStyles({
    error: {
      marginTop: 4
    }
  });
};

var InputNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  function InputNumber() {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputNumber).apply(this, arguments));
    _this.invalidChars = ["-", "+", "e"];

    _this.onKeyDown = function (event) {
      if (_this.invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    };

    _this.onInput = function (event) {
      if (event.target.value) {
        event.target.value = event.target.value.replace(/[e\+\-]/gi, "");
      }

      return event;
    };

    return _this;
  }

  _createClass(InputNumber, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          status = _this$props.status,
          classes = _this$props.classes;
      var isDisabled = status === 'DISABLED';
      var isRequired = checkRequired(this.props);
      var inputProps = {};

      if (meta.min !== undefined) {
        inputProps.min = meta.min;
      }

      if (meta.max !== undefined) {
        inputProps.max = meta.max;
      }

      if (meta.step !== undefined) {
        inputProps.step = meta.step;
      }

      if (meta.maxLength !== undefined) {
        inputProps.maxLength = meta.maxLength;
      }

      return React.createElement(React.Fragment, null, React.createElement(TextField, Object.assign({
        id: 'outlined-dense',
        label: meta.label,
        margin: 'dense',
        variant: 'outlined',
        fullWidth: true
      }, handler(), {
        error: touched && hasError('required'),
        required: isRequired,
        disabled: isDisabled,
        type: 'number',
        inputProps: inputProps,
        onKeyDown: this.onKeyDown
      })), touched && hasError('required') && React.createElement(FormHelperText, {
        className: classes.error,
        error: true
      }, "\u041F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"));
    }
  }]);

  return InputNumber;
}(React.Component);

export default withStyles(styles, {
  name: 'InputNumber'
})(InputNumber);